import classNames from 'classnames';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const GridItem = ({
  className,
  children,
  ...sizes
}) => {
  const classes = classNames(Object.keys(sizes).map(size => `col-${size}-${sizes[size]}`), className);
  return /*#__PURE__*/_jsx("div", {
    className: classes,
    children: children
  });
};